import React from 'react';
import { Box, Typography } from '@mui/material';
import BtnComponent from '../components/buttonComponent/BtnComponent';
import palefatalerror from '../assests/palefatalerror.svg';
import { GENERIC_ERROR_MESSAGE } from '../shared/constants';
import { Link } from 'react-router-dom';
import { NOT_FOUND } from '../shared/Strings';

const NotFound = ({ bacTokenExpiry}) => {

  const redirectToBac = () => {
    window.location.href = `https://bactpa.vbagateway.com/`;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: '160px',
          flexDirection: 'column',
          m: 3,
        }}>
        <img
          src={palefatalerror}
          alt={NOT_FOUND.IMAGE_ALTERNATE_TEXT.ERROR_IMG}
        />
      </Box>
      {!bacTokenExpiry &&
        <Box>
        <Typography variant="h4" sx={{ mt: '24px', fontWeight: 600 }}>
          {GENERIC_ERROR_MESSAGE.TITLE}
        </Typography>
      </Box>
      }
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: '16px',
          alignItems: 'center',
          flexDirection: 'row',
          textAlign: 'center',
          width: '472px',
        }}>
        <Typography variant={bacTokenExpiry ? 'h5' : 'h6'} sx={{ m: 2 }}>
          {bacTokenExpiry
            ? GENERIC_ERROR_MESSAGE.BAC_TOKEN_EXPIRY_MESSAGE
            : GENERIC_ERROR_MESSAGE.SUBTITLE}
        </Typography>
      </Box>

      {bacTokenExpiry ? (
        <Box sx={{ width: '100%', maxWidth: '424px' }}>
          <BtnComponent
            fullWidth
            sx={{ mt: '40px' }}
            title={NOT_FOUND.BUTTON_TEXT.BAC_TOKEN_EXPIRY}
            onClick={redirectToBac}
          />
        </Box>
      ) : (
        <Box sx={{ width: '100%', maxWidth: '424px' }}>
          <BtnComponent
            component={Link}
            fullWidth
            sx={{ mt: '40px' }}
            title={NOT_FOUND.BUTTON_TEXT.REFRESH}
            name="refresh"
            to={'/'}
          />
        </Box>
      )}
    </Box>
  );
};

export default NotFound;
